import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class WeatherDemoService {

  private _weather: IWeatherData[];

  constructor() {
    this._weather = [
      {
        LastUpdated: new Date(),
        Exception: "",
        Headline: {
          EffectiveDate: new Date("2019-12-10T13:00:00-05:00"),
          EffectiveEpochDate: 1576000800,
          Severity: 4,
          Text: "Rain from tomorrow afternoon until before dawn Wednesday, when it will change to snow and accumulate a coating to an inch before ending early Wednesday morning",
          Category: "snow/rain",
          EndDate: new Date("2019-12-11T10:00:00-05:00"),
          EndEpochDate: 1576076400,
          MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/extended-weather-forecast/2695_pc?lang=en-us",
          Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?lang=en-us"
        },
        DailyForecasts: [
          {
            DateTime: new Date("2019-12-09T07:00:00-05:00"),
            EpochDate: 1575892800,
            Sun: {
              Rise: new Date("2019-12-09T07:08:00-05:00"),
              EpochRise: 1575893280,
              Set: new Date("2019-12-09T16:29:00-05:00"),
              EpochSet: 1575926940,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Moon: {
              Rise: new Date("2019-12-09T15:06:00-05:00"),
              EpochRise: 1575921960,
              Set: new Date("2019-12-10T05:18:00-05:00"),
              EpochSet: 1575973080,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Temperature: {
              Minimum: {
                Value: 51.0,
                Unit: "F",
                UnitType: 18
              },
              Maximum: {
                Value: 54.0,
                Unit: "F",
                UnitType: 18
              }
            },
            RealFeelTemperature: { Minimum: { Value: 44, Unit: "F", UnitType: 18 }, Maximum: { Value: 50.0, Unit: "F", UnitType: 18 } },
            RealFeelTemperatureShade: { Minimum: { Value: 44, Unit: "F", UnitType: 18 }, Maximum: { Value: 49.0, Unit: "F", UnitType: 18 } },
            HoursOfSun: 0.1,
            DegreeDaySummary: { Heating: { Value: 13, Unit: "F", UnitType: 18 }, Cooling: { Value: 0.0, Unit: "F", UnitType: 18 } },
            AirAndPollen: [],
            Day: {
              Icon: 18,
              IconPhrase: "Rain",
              HasPrecipitation: true,
              PrecipitationType: "Rain",
              PrecipitationIntensity: "Light",
              ShortPhrase: "Mild with rain, then fog",
              LongPhrase: "Mild with rain, then areas of fog this afternoon",
              PrecipitationProbability: 92,
              ThunderstormProbability: 0,
              RainProbability: 92,
              SnowProbability: 0,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 6.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 147, Localized: "SSE", English: "SSE" }
              },
              WindGust: {
                Speed: { Value: 18.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 147, Localized: "SSE", English: "SSE" }
              },
              TotalLiquid: { Value: 0.77, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.77, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 7.5,
              HoursOfRain: 7.5,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 100
            },
            Night: {
              Icon: 12,
              IconPhrase: "Showers",
              HasPrecipitation: true,
              PrecipitationType: "Rain",
              PrecipitationIntensity: "Moderate",
              ShortPhrase: "Fog; rain this evening",
              LongPhrase: "Cloudy, fog, mild; evening rain, then spotty drizzle",
              PrecipitationProbability: 67,
              ThunderstormProbability: 0,
              RainProbability: 67,
              SnowProbability: 1,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 9.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 207, Localized: "SSW", English: "SSW" }
              },
              WindGust: {
                Speed: { Value: 13.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 207, Localized: "SSW", English: "SSW" }
              },
              TotalLiquid: { Value: 0.31, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.31, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 4.0,
              HoursOfRain: 4.0,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 98
            },
            Sources: ["AccuWeather"],
            MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us",
            Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us"
          }
        ]
      },
      {
        LastUpdated: new Date(),
        Exception: "",
        Headline: {
          EffectiveDate: new Date("2019-12-10T13:00:00-05:00"),
          EffectiveEpochDate: 1576000800,
          Severity: 4,
          Text: "Rain from tomorrow afternoon until before dawn Wednesday, when it will change to snow and accumulate a coating to an inch before ending early Wednesday morning",
          Category: "snow/rain",
          EndDate: new Date("2019-12-11T10:00:00-05:00"),
          EndEpochDate: 1576076400,
          MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/extended-weather-forecast/2695_pc?lang=en-us",
          Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?lang=en-us"
        },
        DailyForecasts: [
          {
            DateTime: new Date("2019-12-10T07:00:00-05:00"),
            EpochDate: 1575892800,
            Sun: {
              Rise: new Date("2019-12-09T07:08:00-05:00"),
              EpochRise: 1575893280,
              Set: new Date("2019-12-09T16:29:00-05:00"),
              EpochSet: 1575926940,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Moon: {
              Rise: new Date("2019-12-09T15:06:00-05:00"),
              EpochRise: 1575921960,
              Set: new Date("2019-12-10T05:18:00-05:00"),
              EpochSet: 1575973080,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Temperature: {
              Minimum: {
                Value: 35.0,
                Unit: "F",
                UnitType: 18
              },
              Maximum: {
                Value: 60.0,
                Unit: "F",
                UnitType: 18
              }
            },
            RealFeelTemperature: { Minimum: { Value: 29, Unit: "F", UnitType: 18 }, Maximum: { Value: 58.0, Unit: "F", UnitType: 18 } },
            RealFeelTemperatureShade: { Minimum: { Value: 44, Unit: "F", UnitType: 18 }, Maximum: { Value: 49.0, Unit: "F", UnitType: 18 } },
            HoursOfSun: 0.1,
            DegreeDaySummary: { Heating: { Value: 13, Unit: "F", UnitType: 18 }, Cooling: { Value: 0.0, Unit: "F", UnitType: 18 } },
            AirAndPollen: [],
            Day: {
              Icon: 12,
              IconPhrase: "Showers",
              HasPrecipitation: true,
              PrecipitationType: "Rain",
              PrecipitationIntensity: "Moderate",
              ShortPhrase: "A touch of afternoon rain",
              LongPhrase: "Cloudy and not as cool; a shower in the morning followed by a little rain in the afternoon",
              PrecipitationProbability: 70,
              ThunderstormProbability: 20,
              RainProbability: 70,
              SnowProbability: 0,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 9.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 240, Localized: "WSW", English: "WSW" }
              },
              WindGust: {
                Speed: { Value: 12.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 240, Localized: "WSW", English: "WSW" }
              },
              TotalLiquid: { Value: 0.23, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.23, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 7.5,
              HoursOfRain: 3,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 99
            },
            Night: {
              Icon: 29,
              IconPhrase: "Rain and snow",
              HasPrecipitation: true,
              PrecipitationType: "Mixed",
              PrecipitationIntensity: "Moderate",
              ShortPhrase: "Periods of rain in the evening",
              LongPhrase: "Cloudy and colder; evening rain followed by a little rain mixing with, then changing to snow late",
              PrecipitationProbability: 69,
              ThunderstormProbability: 0,
              RainProbability: 66,
              SnowProbability: 53,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 8.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 323, Localized: "NW", English: "NW" }
              },
              WindGust: {
                Speed: { Value: 12.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 323, Localized: "NW", English: "NW" }
              },
              TotalLiquid: { Value: 0.31, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.31, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 4.0,
              HoursOfRain: 4.0,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 98
            },
            Sources: ["AccuWeather"],
            MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us",
            Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us"
          }
        ]
      },
      {
        LastUpdated: new Date(),
        Exception: "",
        Headline: {
          EffectiveDate: new Date("2019-12-10T13:00:00-05:00"),
          EffectiveEpochDate: 1576000800,
          Severity: 4,
          Text: "Rain from tomorrow afternoon until before dawn Wednesday, when it will change to snow and accumulate a coating to an inch before ending early Wednesday morning",
          Category: "snow/rain",
          EndDate: new Date("2019-12-11T10:00:00-05:00"),
          EndEpochDate: 1576076400,
          MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/extended-weather-forecast/2695_pc?lang=en-us",
          Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?lang=en-us"
        },
        DailyForecasts: [
          {
            DateTime: new Date("2019-12-10T07:00:00-05:00"),
            EpochDate: 1575892800,
            Sun: {
              Rise: new Date("2019-12-09T07:08:00-05:00"),
              EpochRise: 1575893280,
              Set: new Date("2019-12-09T16:29:00-05:00"),
              EpochSet: 1575926940,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Moon: {
              Rise: new Date("2019-12-09T15:06:00-05:00"),
              EpochRise: 1575921960,
              Set: new Date("2019-12-10T05:18:00-05:00"),
              EpochSet: 1575973080,
              Phase: "WaxingGibbous",
              Age: 13
            },
            Temperature: {
              Minimum: {
                Value: 24.0,
                Unit: "F",
                UnitType: 18
              },
              Maximum: {
                Value: 39.0,
                Unit: "F",
                UnitType: 18
              }
            },
            RealFeelTemperature: { Minimum: { Value: 29, Unit: "F", UnitType: 18 }, Maximum: { Value: 58.0, Unit: "F", UnitType: 18 } },
            RealFeelTemperatureShade: { Minimum: { Value: 44, Unit: "F", UnitType: 18 }, Maximum: { Value: 49.0, Unit: "F", UnitType: 18 } },
            HoursOfSun: 0.1,
            DegreeDaySummary: { Heating: { Value: 13, Unit: "F", UnitType: 18 }, Cooling: { Value: 0.0, Unit: "F", UnitType: 18 } },
            AirAndPollen: [],
            Day: {
              Icon: 19,
              IconPhrase: "Flurries",
              HasPrecipitation: true,
              PrecipitationType: "Snow",
              PrecipitationIntensity: "Moderate",
              ShortPhrase: "Snow early in the morning",
              LongPhrase: "A little accumulation of snow early in the morning; otherwise, mostly cloudy and much colder",
              PrecipitationProbability: 57,
              ThunderstormProbability: 20,
              RainProbability: 40,
              SnowProbability: 50,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 9.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 240, Localized: "WSW", English: "WSW" }
              },
              WindGust: {
                Speed: { Value: 12.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 240, Localized: "WSW", English: "WSW" }
              },
              TotalLiquid: { Value: 0.23, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.23, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 7.5,
              HoursOfRain: 3,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 99
            },
            Night: {
              Icon: 34,
              IconPhrase: "Mostly clear",
              HasPrecipitation: false,
              PrecipitationType: "Mixed",
              PrecipitationIntensity: "",
              ShortPhrase: "A moonlit sky",
              LongPhrase: "A moonlit sky",
              PrecipitationProbability: 4,
              ThunderstormProbability: 0,
              RainProbability: 1,
              SnowProbability: 4,
              IceProbability: 0,
              Wind: {
                Speed: { Value: 8.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 323, Localized: "NW", English: "NW" }
              },
              WindGust: {
                Speed: { Value: 12.0, Unit: "mi/h", UnitType: 9 },
                Direction: { Degrees: 323, Localized: "NW", English: "NW" }
              },
              TotalLiquid: { Value: 0.31, Unit: "in", UnitType: 1 },
              Rain: { Value: 0.31, Unit: "in", UnitType: 1 },
              Snow: { Value: 0.0, Unit: "in", UnitType: 1 },
              Ice: { Value: 0.0, Unit: "in", UnitType: 1 },
              HoursOfPrecipitation: 4.0,
              HoursOfRain: 4.0,
              HoursOfSnow: 0.0,
              HoursOfIce: 0.0,
              CloudCover: 98
            },
            Sources: ["AccuWeather"],
            MobileLink: "http://m.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us",
            Link: "http://www.accuweather.com/en/us/secaucus-nj/07094/daily-weather-forecast/2695_pc?day=1&lang=en-us"
          }
        ]
      }
    ];
  }

  get(date: string) {
    var d = new Date(date);
    var dayNo = d.getDay() % 3;
    var index = dayNo >= 0 && dayNo <= 2 ? dayNo : 0;
    return of(this._weather[index]);
  }
}

export interface IWeatherData {
  Headline: IHeadlineItem;
  DailyForecasts: IDailyForecastsItem[];
  LastUpdated: Date;
  Exception: string;
}

interface IDailyForecastsItem {
  DateTime: Date;
  EpochDate: number;
  Sun: IRiseItem;
  Moon: IRiseItem;
  Temperature: ITemperatureItem;
  RealFeelTemperature: ITemperatureItem;
  RealFeelTemperatureShade: ITemperatureItem;
  HoursOfSun: number;
  DegreeDaySummary: IDegreeSummaryItem;
  AirAndPollen: IAirAndPollenItem[];
  Day: IWeatherItem;
  Night: IWeatherItem;
  Sources: string[];
  MobileLink: string;
  Link: string;
}

interface IHeadlineItem {
  EffectiveDate: Date;
  EffectiveEpochDate: number;
  Severity: number;
  Text: string;
  Category: string;
  EndDate: Date;
  EndEpochDate: number;
  MobileLink: string;
  Link: string;
}

interface IRiseItem {
  Rise: Date;
  EpochRise: number;
  Set: Date;
  EpochSet: number;
  Phase: string;
  Age: number;
}

interface ITemperatureItem {
  Minimum: IValueItem;
  Maximum: IValueItem;
}

interface IWeatherItem {
  Icon: number;
  IconPhrase: string;
  HasPrecipitation: boolean;
  PrecipitationType: string;
  PrecipitationIntensity: string;
  ShortPhrase: string;
  LongPhrase: string;
  PrecipitationProbability: number;
  ThunderstormProbability: number;
  RainProbability: number;
  SnowProbability: number;
  IceProbability: number;
  Wind: IWindItem;
  WindGust: IWindItem;
  TotalLiquid: IValueItem;
  Rain: IValueItem;
  Snow: IValueItem;
  Ice: IValueItem;
  HoursOfPrecipitation: number;
  HoursOfRain: number;
  HoursOfSnow: number;
  HoursOfIce: number;
  CloudCover: number;
}

interface IWindItem {
  Speed: IValueItem;
  Direction: IDirectionItem;
}

interface IDirectionItem {
  Degrees: number;
  Localized: string;
  English: string;
}

interface IDegreeSummaryItem {
  Heating: IValueItem;
  Cooling: IValueItem;
}

interface IValueItem {
  Value: number;
  Unit: string;
  UnitType: number;
}

interface IAirAndPollenItem {
  Name: string;
  Value: number;
  Category: string;
  CategoryValue: number;
  Type: string;
}





